"use client";

const SUGGESTIONS = [
  "보톡스와 필러의 차이가 뭔가요?",
  "주름 개선에 가장 효과적인 시술은?",
  "리프팅 시술을 비교해주세요",
  "모공 축소에 좋은 레이저는?",
  "시술 후 관리 방법이 궁금해요",
  "탄력 개선 시술 추천해주세요",
];

interface SuggestedQuestionsProps {
  onSelect: (question: string) => void;
}

export function SuggestedQuestions({ onSelect }: SuggestedQuestionsProps) {
  return (
    <div className="flex flex-wrap justify-center gap-2 px-4">
      {SUGGESTIONS.map((q) => (
        <button
          key={q}
          onClick={() => onSelect(q)}
          className="text-muted-foreground rounded-2xl border border-gray-200 bg-white px-4 py-2.5 text-sm transition-all hover:border-violet-300 hover:bg-violet-50 hover:text-violet-700 hover:shadow-sm"
        >
          {q}
        </button>
      ))}
    </div>
  );
}
